import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD__ml_asset_control_net } from '../../../_fields/ml_asset/guidance/FIELD__ml_asset_control_net';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION_SD__base } from '../INVOCATION_SD__base';
import { INVOCATION_SD__denoise_latents_pipeline } from '../denoise/INVOCATION_SD__denoise_latents_pipeline';

export class INVOCATION_SD__control_net extends INVOCATION_SD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_SD__CONTROL_NET;

  /*
   * INPUTS
   */

  @FIELD__ml_asset_control_net.init_as_input()
  control_net!: FIELD__ml_asset_control_net;

  /*
   * EVENTS
   */

  edges__try_autocreate(graph: DTO_GRAPH__instance) {
    super.edges__try_autocreate(graph);

    let nodes_denoise = graph.nodes__get_by_type(INVOCATION_SD__denoise_latents_pipeline);

    if (nodes_denoise.length != 1) return;

    /*
     * INVOCATION_SD__control_net -> INVOCATION_SD__denoise_latents_pipeline
     */

    this.edges__try_autocreate_from_left_to_right_one_field(graph, INVOCATION_SD__denoise_latents_pipeline, ['control'], this.control_net, false);
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.SD__CONTROL_NET);
  }
}
